export default __webpack_public_path__ + "static/media/utility1.05c5d676.jpg";